// extracted by mini-css-extract-plugin
module.exports = {"container":"SkeletonRow_container__1AtWQ","skeleton":"SkeletonRow_skeleton__24Ywv"};